import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: inherit;
  ${props =>
    props.isVoiceOver &&
    css`
      position: fixed;
      top: 87%;
      height: 84px;
    `}
`;

export default Wrapper;
